import { render } from "./Carousel.vue?vue&type=template&id=414d7032"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
script.render = render

export default script